import "./Contact.module.css";
import PrimaryNavigation from "@/reusable_sections/Header";
import GetAPrecisionQuote from "./sections/GetAPrecisionQuote";
import OperationalHours from "./sections/OperationalHours";
import EngineeringFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <PrimaryNavigation />
      <GetAPrecisionQuote />
      <OperationalHours />
      <EngineeringFooter />
    </div>;
}